import { 
	Show, 
	SimpleShowLayout, 
	TextField, 
	DateField, 
	ReferenceField,
	Labeled
} from 'react-admin';
import { Grid } from '@mui/material';

const DatingEventCouponShow = () => (
	<Show resource="events-coupons">
		<SimpleShowLayout>
			<Grid spacing={2} container>
				<Grid item xs={12} md={6}>
					<Labeled label="קוד קופון">
						<TextField source="code" dir="ltr" />
					</Labeled>
				</Grid>
				<Grid item xs={12} md={6}>
					<Labeled label="אירוע דייטינג">
						<TextField source="eventId.title" dir="rtl" />
					</Labeled>
				</Grid>
				<Grid item xs={12} md={6}>
					<Labeled label="תאריך האירוע">
						<TextField source="eventId.time" />
					</Labeled>
				</Grid>
				<Grid item xs={12} md={6}>
					<Labeled label="שימוש">
						<TextField source="isUsed" />
					</Labeled>
				</Grid>
				<Grid item xs={12} md={6}>
					<Labeled label="נוצר בתאריך">
						<DateField source="createdAt" />
					</Labeled>
				</Grid>
				<Grid item xs={12} md={6}>
					<Labeled label="עודכן בתאריך">
						<DateField source="updatedAt" />
					</Labeled>
				</Grid>
			</Grid>
		</SimpleShowLayout>
	</Show>
);

export default DatingEventCouponShow;
